import { useLayoutEffect } from 'react';

export function useDialogCloseTrackingLabel(show: boolean, dialogTitleId: string) {
    useLayoutEffect(() => {
        if (!show) {
            return;
        }

        const closeButtons = document.querySelectorAll<HTMLElement>('.modal.show [data-testid="close"]');
        closeButtons
            .item(closeButtons.length - 1)
            ?.setAttribute('data-track-ga-event-label', `dialog::closed::${dialogTitleId}`);
    }, [show, dialogTitleId]);
}
